import { CopyOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { FillModal } from "../../../../../../components";
import { useMobile } from "../../../../../../context/MobileContext";
import { moneyFormat } from "../../../../../../plugins/numberFormat";
import { copyText, envChangeType, formatDate } from "../../../../../../plugins/utils";
import { useWallet } from "../../../../context/WalletContext";
import WalletRecord from "../../../WalletRecord";
import styles from "./style.module.scss";
import "./style.scss";

const Record = ({ data, hasNextPage, fetchNextPage, isFetchingNextPage, setCurrentPage }) => {
  const { t } = useTranslation();
  const { isMobile } = useMobile();
  const { rechargeRecordItems, rechargeRecordActiveTab, setRechargeRecordActiveTab } = useWallet();
  const [openModal, setOpenModal] = useState(false);
  const [modalData, setModalData] = useState({});

  const columns = [
    {
      title: t("label.items"),
      key: "items",
      render: () => t("label.amount"),
      hide: isMobile,
    },
    {
      title: t("label.time"),
      dataIndex: "createtime",
      key: "createtime",
      render: (dom) => formatDate(dom),
    },
    {
      title: t("label.status"),
      dataIndex: "audit_status_text",
      key: "status",
    },
    {
      title: t("label.amount"),
      dataIndex: "money",
      key: "money",
      render: (dom) =>
        moneyFormat(dom) + " " + t(`currency.unit.${envChangeType("REACT_APP_DEFAULT_CURRENCY")}`),
    },
    {
      title: t("label.orderNumber"),
      key: "orderNumber",
      dataIndex: "sn",
      render: (dom) => {
        return (
          <div className="copyContainer" onClick={() => copyText(dom)}>
            {dom}
            <span className="copy">
              <CopyOutlined />
            </span>
          </div>
        );
      },
      hide: isMobile,
    },
  ];

  const handleClickCard = (_data) => {
    setOpenModal(true);
    setModalData({
      title: t("label.orderNumber"),
      content: <div className={styles.orderNumber}>{_data?.sn} </div>,
      buttonText: t("normal.copyAndConfirm.upper"),
      onOk: () => {
        copyText(_data?.sn);
        setOpenModal(false);
      },
    });
  };

  useEffect(() => {
    console.log(data);
  }, [data]);

  return (
    <>
      <WalletRecord
        data={data}
        items={rechargeRecordItems}
        activeTab={rechargeRecordActiveTab}
        setActiveTab={setRechargeRecordActiveTab}
        columns={columns}
        style={{ background: "linear-gradient(90deg, #ffc702 0%, #fbeba3 100%)" }}
        className={"recharge-record-table"}
        hasNextPage={hasNextPage}
        fetchNextPage={fetchNextPage}
        isFetchingNextPage={isFetchingNextPage}
        onClickCard={handleClickCard}
        setCurrentPage={setCurrentPage}
        timeParam={"createtime"}
      />
      <FillModal open={openModal} setOpen={setOpenModal} data={modalData} />
    </>
  );
};

export default Record;
